var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.09 40.5601C32.9571 40.5601 33.66 39.8571 33.66 38.9901C33.66 38.123 32.9571 37.42 32.09 37.42C31.2229 37.42 30.52 38.123 30.52 38.9901C30.52 39.8571 31.2229 40.5601 32.09 40.5601Z",
    fill: "#00C9B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 40.5601C22.0771 40.5601 22.78 39.8571 22.78 38.9901C22.78 38.123 22.0771 37.42 21.21 37.42C20.3429 37.42 19.64 38.123 19.64 38.9901C19.64 39.8571 20.3429 40.5601 21.21 40.5601Z",
    fill: "#00C9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.09 33.8H14.53C13.62 33.8 12.8501 33.12 12.7301 32.22L8.94005 11.55C8.80005 10.46 9.65005 9.48999 10.75 9.48999H43.8901C44.9901 9.48999 45.8401 10.46 45.7001 11.55L41.91 32.22C41.79 33.12 41.02 33.8 40.11 33.8H40.09Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95004 11.55L7.17004 1.82007H1.77002",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.84 21.7601L25.67 26.1201L34.27 17.4001",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.fb8e218ee90e9b6bb0b0ca52bb4c0cca.svg";
export { ForwardRef as ReactComponent };